import {
  GET_SURVEYTEMPLATEDETAIL,
  GET_SURVEYTEMPLATEDETAIL_SUCCESS,
  GET_SURVEYTEMPLATEDETAIL_FAIL,
  DELETE_SURVEYTEMPLATEDETAIL,
  DELETE_SURVEYTEMPLATEDETAIL_SUCCESS,
  DELETE_SURVEYTEMPLATEDETAIL_FAIL,
  UPDATE_SURVEYTEMPLATEDETAIL,
  UPDATE_SURVEYTEMPLATEDETAIL_SUCCESS,
  UPDATE_SURVEYTEMPLATEDETAIL_FAIL,
  ADD_NEW_SURVEYTEMPLATEDETAIL,
  ADD_SURVEYTEMPLATEDETAIL_SUCCESS,
  ADD_SURVEYTEMPLATEDETAIL_FAIL,
  SURVEYTEMPLATEDETAIL_LOADING,
  SURVEYTEMPLATEDETAIL_RESET,
  SURVEYTEMPLATEDETAIL_RESET_CREATE,
} from "./actionType";

export const resetSurveyTemplateDetailState = (actionType) => ({
  type: SURVEYTEMPLATEDETAIL_RESET,
  payload: { actionType },
});

export const resetSurveyTemplateDetailCreateState = (actionType) => ({
  type: SURVEYTEMPLATEDETAIL_RESET_CREATE,
  payload: { actionType },
});

export const getSurveyTemplateDetailSuccess = (actionType, data) => ({
  type: GET_SURVEYTEMPLATEDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getSurveyTemplateDetailFail = (actionType, error) => ({
  type: GET_SURVEYTEMPLATEDETAIL_FAIL,
  payload: { actionType, error },
});

export const getSurveyTemplateDetail = (data) => ({
  type: GET_SURVEYTEMPLATEDETAIL,
  payload: data,
});

export const getSurveyTemplateDetailLoading = () => ({
  type: SURVEYTEMPLATEDETAIL_LOADING,
});

export const deleteSurveyTemplateDetail = (data) => ({
  type: DELETE_SURVEYTEMPLATEDETAIL,
  payload: data,
});

export const deleteSurveyTemplateDetailSuccess = (data) => ({
  type: DELETE_SURVEYTEMPLATEDETAIL_SUCCESS,
  payload: data,
});

export const deleteSurveyTemplateDetailFail = (error) => ({
  type: DELETE_SURVEYTEMPLATEDETAIL_FAIL,
  payload: error,
});

export const updateSurveyTemplateDetail = (data) => ({
  type: UPDATE_SURVEYTEMPLATEDETAIL,
  payload: data,
});

export const updateSurveyTemplateDetailFail = (error) => ({
  type: UPDATE_SURVEYTEMPLATEDETAIL_FAIL,
  payload: error,
});

export const updateSurveyTemplateDetailSuccess = (data) => ({
  type: UPDATE_SURVEYTEMPLATEDETAIL_SUCCESS,
  payload: data,
});

export const addNewSurveyTemplateDetail = (data) => ({
  type: ADD_NEW_SURVEYTEMPLATEDETAIL,
  payload: data,
});

export const addSurveyTemplateDetailSuccess = (data) => ({
  type: ADD_SURVEYTEMPLATEDETAIL_SUCCESS,
  payload: data,
});

export const addSurveyTemplateDetailFail = (error) => ({
  type: ADD_SURVEYTEMPLATEDETAIL_FAIL,
  payload: error,
});
